import { ReactNode } from 'react';

import { Box, Popover, PopoverProps, Text } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';

type HoverPopoverType = {
	text: string;
	children: ReactNode;
} & PopoverProps;

export const HoverPopover = ({ children, text, ...rest }: HoverPopoverType) => {
	const [opened, { close, open }] = useDisclosure(false);
	return (
		<Popover width={200} shadow="md" opened={opened} {...rest}>
			<Popover.Target>
				<Box onMouseEnter={open} onMouseLeave={close}>
					{children}
				</Box>
			</Popover.Target>
			<Popover.Dropdown style={{ pointerEvents: 'none' }}>
				<Text size="sm">{text}</Text>
			</Popover.Dropdown>
		</Popover>
	);
};
